import React, { useState, useEffect } from "react";
import { Card, Table, Badge } from 'react-bootstrap';
import { Avatar } from 'primereact/avatar';
import { Button } from 'primereact/button';
import { Link } from "react-router-dom";
import axios from "axios";
import { useAuth } from '../context/AuthContext';
import config from '../config';

const Client_projects = ({ clientId }) => {
    const { accessToken } = useAuth();
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProjects = async () => {
            try {
                const response = await axios.get(`${config.apiBASEURL}/InvoiceRoutes/accepted-projects/${clientId}`, {
                    headers: { Authorization: `Bearer ${accessToken}` }
                });
                if (response.status === 200) {
                    setProjects(response.data);
                } else {
                    setProjects([]);
                }


            } catch (error) {
                console.error("Error fetching accepted projects:", error);
            } finally {
                setLoading(false);
            }
        };

        if (clientId) fetchProjects();
    }, [clientId, accessToken]);

    const statusOrder = ['Todo', 'InProgress', 'InReview', 'InChanges', 'Completed'];
    const getProjectInitial = (name) => name ? name.charAt(0).toUpperCase() : "P";

    return (
        <>
            {loading ? (
                <p>Loading Projects...</p>
            ) : projects.length === 0 ? (
                <p>No Projects found.</p>
            ) : (
                <ul className='ct_prolist'>
                    {projects.map(({ project, payment_status, estimated_date }) => (
                        <li key={project.project_id}>
                            <Card>
                                <Card.Header className='px-3'>
                                    <div className='d-flex justify-content-start align-items-start'>
                                    <Avatar label={getProjectInitial(project.project_name)} style={{ backgroundColor: '#2196F3', color: '#ffffff' }} shape="circle" />
                                        <div className='ms-3'>
                                            <h6 className='mb-1 d-block'>{project.project_name}</h6>
                                            <small className='d-block text-danger'>
                                                <em >Estimated Due Date</em> :  {new Date(estimated_date).toLocaleDateString('en-GB')}
                                            </small>
                                            <small className='d-block text-black '>
                                                <em >Lead</em> :  {project.lead?.first_name} {project.lead?.last_name}
                                            </small>
                                        </div>
                                    </div>
                                </Card.Header>
                                <Card.Body className='py-2'>
                                    <ul className='clitpro_det'>
                                        <li>
                                            <small>Start Date</small>
                                            <small className='text-black'>{new Date(project.start_date).toLocaleDateString('en-GB')}</small>
                                        </li>
                                        <li>
                                            <small>Deadline</small>
                                            <small className='text-black'>{new Date(project.end_date).toLocaleDateString('en-GB')}</small>
                                        </li>
                                        <li>
                                            <small>Status</small>
                                            <small className='text-black'> <Badge bg={payment_status === 'Full_Payment' ? 'success' : 'warning'}>
                                                {payment_status.replace('_', ' ')}
                                            </Badge></small>
                                        </li>

                                    </ul>
                                </Card.Body>
                                <Card.Footer>
                                    <span className='d-flex justify-content-between align-items-center'>
                                    {statusOrder.map((status) => {
                                                const task = project.task_counts?.find(t => t.status === status);
                                                return task ? (
                                                    <small key={status}>
                                                        <em className='d-block'>{status}</em> 
                                                        <b className={`text-${status === 'Completed' ? 'success' : status === 'InProgress' ? 'primary' : status === 'Todo' ? 'info' : status === 'InReview' ? 'warning' : status === 'InChanges' ? 'help' : 'danger'}`}>{task.task_count}</b>
                                                    </small>
                                                ) : null;
                                            })}

                                    </span>
                                </Card.Footer>
                            </Card>
                        </li>
                    ))}
                </ul>

            )}
        </>
    );
};

export default Client_projects;